import client from '../utils/client';
import { discountGroupsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const discountGroupService = {
  discountGroupsList,
  addDiscountGroup,
  getDiscountGroup,
  updateDiscountGroup
}

function discountGroupsList(pageID, perPage, searchInput) {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(discountGroupsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addDiscountGroup(formDate) {
  return client.post(discountGroupsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getDiscountGroup(discountGroupID) {
  return client.get(discountGroupsUrl + '/' + discountGroupID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateDiscountGroup(formDate) {
  return client.post(discountGroupsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}